/**
 * Shared-device route helper.
 *
 * Checks whether a given pathname belongs to the shared-device route space
 * (/shared-device or /shared-device/*). Kept as a pure function with no
 * Firebase imports so it can be safely used anywhere (routing, bootstrapping, etc.).
 */
export const isSharedDevicePath = (pathname: string | null | undefined): boolean => {
  if (!pathname || typeof pathname !== 'string') return false
  return pathname === '/shared-device' || pathname.startsWith('/shared-device/')
}
